import PropTypes from 'prop-types'
import {
  Box,
  // Button,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
} from '@chakra-ui/react'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function SearchBar({ value, handleSearch }) {
  return (
    <HStack w="100%">
      <Box w="100%">
        <InputGroup>
          <InputLeftElement zIndex={0} pointerEvents="none">
            <FontAwesomeIcon icon={faSearch} />
          </InputLeftElement>
          <Input
            value={value || ''}
            onChange={handleSearch}
            placeholder="Buscar por RUT o NN"
          />
        </InputGroup>
      </Box>
    </HStack>
  )
}

SearchBar.propTypes = {
  handleSearch: PropTypes.func,
  value: PropTypes.string,
}
